import { render, staticRenderFns } from "./cpt-dataV-scrollTable.vue?vue&type=template&id=4369e615&scoped=true"
import script from "./cpt-dataV-scrollTable.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-scrollTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369e615",
  null
  
)

export default component.exports